// moved to Proteus

// requires videotranscripts.js
var whyBuy4i = function(){
	var VideoTranscripts = new videoTranscripts4i(),
		
	init = function(){
		VideoTranscripts.Init();
	};
	return{
		Init: init
	};
};

(function(){
	var whyBuyPage = new whyBuy4i();
	whyBuyPage.Init();
})();